export const TIPO_VIA_INE = {
  ACCES: "ACCE",
  ACCESO: "ACCES",
  ACEQUIA: "ACEQ",
  ACERA: "ACERA",
  ALAMEDA: "ALAM",
  ALDAPA: "ALDAP",
  ALDEA: "ALDEA",
  ALQUERIA: "ALQUE",
  ALTO: "ALTO",
  ANDADOR: "ANDAD",
  ANGOSTA: "ANGTA",
  APEADEIRO: "APDRO",
  APEADERO: "APDRO",
  APARTAMENTS: "APTES",
  APARTAMENTOS: "APTOS",
  ARBOLEDA: "ARB",
  ARRABAL: "ARRAL",
  ERREKA: "ARREK",
  ARROYO: "ARRY",
  ASSEGADOR: "ASSEG",
  ATAJO: "ATAJO",
  ATALL: "ATAL",
  ATALLO: "ATALL",
  ATZUCAT: "ATZUC",
  AUTOPISTA: "AUTO",
  AUTOVIA: "AUTOV",
  AUZO: "AUZO",
  AUZOTEGI: "AUZOT",
  AUZUNEA: "AUZUN",
  AV: "AV",
  AVENIDA: "AVDA",
  AVINGUDA: "AVGDA",
  AUTOVIA_: "AVIA",
  BALNEARIO: "BALNR",
  BARRIADA: "BARDA",
  BARRI: "BARRI",
  BARRIO: "BARRO",
  BAIXADA: "BDA",
  BELENA: "BELNA",
  BIDE: "BIDE",
  BIDEBIETA: "BIDEB",
  BAJADA: "BJADA",
  BLOC: "BLOC",
  BLOQUE: "BLQUE",
  BARRANQUIL: "BQLLO",
  BARRANCO: "BRANC",
  BARREDUELA: "BRDLA",
  BRAZAL: "BRZAL",
  BASERRIA: "BSRIA",
  BULEVAR: "BULEV",
  BULEVAR_: "BV",
  C: "C",
  CMNO_HONDO: "C.H.",
  CMNO_NUEVO: "C.N.",
  CMNO_VIEJO: "C.V.",
  "C/": "C/",
  CALLE: "CALLE",
  CAMI: "CAMI",
  CAMIN: "CAMIN",
  CAMPA: "CAMPA",
  CAMPING: "CAMPG",
  CAMPO: "CAMPO",
  CANAL: "CANAL",
  CANTON: "CANT",
  CANTINA: "CANTI",
  CANTO: "CANTO",
  CANTERA: "CANTR",
  CANTI_O: "CAN O",
  CARRERADA: "CARRA",
  CARRER: "CARRE",
  CARRERANY: "CARRY",
  CASA: "CASA",
  COBERTIZO: "CBTIZ",
  CIRCUNVALACION: "CCVCN",
  CANELLA: "CELLA",
  CERRO: "CERRO",
  CHALET: "CHLET",
  CINTURON: "CINT",
  CINTURO: "CINT",
  CINYELL: "CINY",
  CIRCUNVALACION_: "CIRCU",
  CALLEJUELA: "CJLA",
  CONJUNTO: "CJTO",
  CALEYA: "CLEYA",
  CALLEJA: "CLLJA",
  CALLEJON: "CLLON",
  CALLIZO: "CLLZO",
  CALEYON: "CLYON",
  CAMINET: "CMNET",
  CAMINO: "CMNO",
  CAMI_O: "CM O",
  CANELLA_: "CNLLA",
  CONVENT: "CNVT",
  CONVENTO: "CNVTO",
  COLONIA: "COL",
  COMPLEJO: "COMPJ",
  COOPERATIVA: "COOP",
  COSTA: "COSTA",
  COSTERA: "COSTE",
  CARRERA: "CRA",
  CRUCEIRO: "CRCRO",
  CORRILLO: "CRLLO",
  CARRERO: "CRO",
  CORRALO: "CRRAL",
  CORRAL: "CRRAL",
  CORREDORCILLO: "CRRCI",
  CORREDOIRA: "CRRDA",
  CORREDERA: "CRRDE",
  CORREDOR: "CRRDO",
  CARRIL: "CRRIL",
  CORRALILLO: "CRRLO",
  CORRIOL: "CRROL",
  CORRIOL_: "CRROL",
  CARRETIL: "CRTIL",
  CORTIJO: "CRTJO",
  CASERIO: "CSRIO",
  COSTANILLA: "CSTAN",
  CARRETERA: "CTRA",
  CARRETERIN: "CTRIN",
  CUADRA: "CUADR",
  "CUEVA/S": "CUEVA",
  CUESTA: "CUSTA",
  CALEXON: "CXON",
  CALZADA: "CZADA",
  CALZADAS: "CZADS",
  CA_ADA: "C ADA",
  DEMARCACION: "DEMAR",
  DEMARCA_IO: "DEMAR",
  DEHESA: "DHSA",
  DISEMINADO: "DISEM",
  DISSEMINAT: "DISSE",
  DRE_ERA: "DRERA",
  "EDIFICIO/S": "EDIFC",
  EIRADO: "EIRAD",
  EMPRESA: "EMPR",
  ENTRADA: "ENTD",
  ENPARANTZA: "EPTZA",
  ERREBAL: "ERREB",
  ERREPIDE: "ERREP",
  ERRIBERA: "ERRIB",
  "ESCALA/S": "ESC",
  "ESCALERA/S": "ESCA",
  ESCALINATA: "ESCAL",
  ESPALDA: "ESLDA",
  ESPIGO: "ESPIG",
  ESTACIO: "ESTAC",
  ESTACION: "ESTCN",
  ESTRADA: "ESTDA",
  ETORBIDEA: "ETDEA",
  ETXADI: "ETXAD",
  ETXARTE: "ETXAR",
  EXPLANADA: "EXPLA",
  EXTRAMUROS: "EXTRM",
  EXTRARRADIO: "EXTRR",
  FALDA: "FALDA",
  FABRICA: "FBRCA",
  FINCA: "FINCA",
  GRAN_VIA: "G.V.",
  GAIN: "GAIN",
  GALERIA: "GALE",
  GALLIZO: "GLLZO",
  GORABIDE: "GORAB",
  GRANJA: "GRANJ",
  GRUP: "GRUP",
  "GRUPO/S": "GRUPO",
  GLORIETA: "GTA",
  HEGI: "HEGI",
  HIPODROMO: "HIPOD",
  HIRIBIDEA: "HIRIB",
  HONDARTZA: "HONDA",
  HOYA: "HOYA",
  ILLA: "ILLA",
  INDA: "INDA",
  JARDI: "JARD",
  JARDINS: "JDIN",
  JARDIN: "JDIN",
  JARDINES: "JDINS",
  KAI: "KAI",
  KALEA: "KALE",
  KARRIK: "KARIK",
  KARRERA: "KARRE",
  KARRIKA: "KARRI",
  KOSTA: "KOSTA",
  KARRIL: "KRRIL",
  LAGO: "LAGO",
  LASTERBIDE: "LASTE",
  LADERA: "LDERA",
  LEKU: "LEKU",
  LLANURA: "LLNRA",
  LLOC: "LLOC",
  LOMA: "LOMA",
  LOMO: "LOMO",
  LORATEGIAK: "LORAK",
  LORATEGI: "LORAT",
  LUGAR: "LUGAR",
  MALECON: "MALEC",
  "MASIA/S": "MASIA",
  MAZO: "MAZO",
  MENDI: "MENDI",
  MERCADO: "MERC",
  MERCAT: "MERCT",
  MIRADOR: "MIRAD",
  MOLL: "MOLL",
  MONTE: "MONTE",
  MIRADOR_: "MRDOR",
  MONASTERIO: "MTRIO",
  MUELLE: "MUELL",
  "NAVE/S": "NAVE",
  NUCLEO: "NCLEO",
  NUDO: "NUDO",
  ONDARTZA: "ONDA",
  PAGO: "PAGO",
  PALACIO: "PALAC",
  PANTANO: "PANT",
  PARC: "PARC",
  PARKE: "PARKE",
  PARTICULAR: "PARTI",
  PAS: "PAS",
  PASAIA: "PASAI",
  PASEALEKUA: "PASEA",
  PASEABIDE: "PASEA",
  PASEO: "PASEO",
  PASSEIG: "PASSE",
  PATIO: "PATIO",
  POBLADO: "PBDO",
  PUEBLO: "PBLO",
  PUJADA: "PDA",
  PASSADIS: "PDIS",
  PG: "PG",
  POLIGONO_INDUST: "PGIND",
  PINAR: "PINAR",
  PISTA: "PISTA",
  "PUJADA, SUBIDA": "PJDA",
  PL: "PL",
  PLA: "PLA",
  PLAYA: "PLAYA",
  PLAZA: "PLAZA",
  PLA_A: "PLA A",
  PLACETA: "PLCET",
  PASILLO: "PLLOP",
  PLAZUELA: "PLZLA",
  PUENTE: "PNTE",
  POLIGONO: "POLIG",
  PONT: "PONT",
  PONTE: "PONTE",
  PORT: "PORT",
  PARQUE: "PQUE",
  PARATGE: "PRAGE",
  PRAIA: "PRAIA",
  PARAJE: "PRAJE",
  PARAXE: "PRAXE",
  PRAZA: "PRAZA",
  PRACI_A: "PRA A",
  PROLONGACIO: "PROL",
  PROLONGACION: "PROL",
  PORTAL: "PRTAL",
  PORTICO: "PRTCO",
  PRAZUELA: "PRZLA",
  PASAJE: "PSAJE",
  PASAXE: "PSAXE",
  PASILLO_: "PSLLO",
  PASEO_MARITIMO: "PSMAR",
  PUERTA: "PTA",
  PARTIDA: "PTDA",
  PASSATGE: "PTGE",
  PORTILLO: "PTILO",
  PUERTILO: "PTLLO",
  PUERTO: "PTO",
  PASADIZO: "PZO",
  PLAZOLETA: "PZTA",
  RABAL: "RABAL",
  RACONADA: "RACDA",
  RACO: "RACO",
  RAMAL: "RAMAL",
  RAMPLA: "RAMPA",
  RAMPA: "RAMPA",
  RAVAL: "RAVAL",
  RAMBLA: "RBLA",
  RIBERA: "RBRA",
  RINCONADA: "RCDA",
  RINCON: "RCON",
  RENTO: "RENTO",
  RESIDENCIAL: "RESID",
  RIERA: "RIERA",
  RONDA: "RONDA",
  ROTONDA: "RTDA",
  RUA: "RUA",
  RUELA: "RUELA",
  RUEIRO: "RUERO",
  SANATORIO: "SANAT",
  SANTUARIO: "SANTU",
  SARBIDE: "SARBI",
  SUBIDA: "SBIDA",
  SECTOR: "SECT",
  SENDER: "SEDER",
  SENDERA: "SEDRA",
  SEKTORE: "SEKT",
  SENDERO: "SEND",
  SENDA: "SENDA",
  SERVENTIA: "SVTIA",
  TALDE: "TALDE",
  TOKI: "TOKI",
  TRANSITO: "TRANS",
  TRASERA: "TRAS",
  TRASEIRA: "TRAS",
  TRAVESSERA: "TRAV",
  TORRENTE: "TRRNT",
  TRAVESSIA: "TRSSI",
  TRAVESIA: "TRVA",
  TRANSVERSAL: "TRVAL",
  URBANIZACION: "URB",
  URBANITZACIO: "URBAT",
  URBANIZAZIO: "URBAZ",
  VALLE: "VALLE",
  VIADUCTE: "VCTE",
  VIADUCTO: "VCTO",
  VECINDARIO: "VECIN",
  VEGA: "VEGA",
  VEINAT: "VENAT",
  VENELA: "VENLA",
  VIA: "VIA",
  VIAL: "VIAL",
  VIARANY: "VIANY",
  VILLA: "VILLA",
  VEREDA: "VREDA",
  VIVIENDAS: "VVDAS",
  XARDIN: "XDIN",
  ZEARKALETA: "ZEHAR",
  ZONA: "ZONA",
  ZUBI: "ZUBI",
  ZUHAIZTI: "ZUHAI",
  ZUMARDI: "ZUMAR",
} as const

export const TipoViaIneKeys = Object.keys(TIPO_VIA_INE) as Array<
  keyof typeof TIPO_VIA_INE
>
export const TipoViaIneOptions = TipoViaIneKeys.map((key) => ({
  label: key,
  value: TIPO_VIA_INE[key],
}))

export type TipoViaIneType = (typeof TIPO_VIA_INE)[keyof typeof TIPO_VIA_INE]
